import React, { useState, useEffect } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';
import './login.css';
import logo from '../assets/merchant-marvels.jpg';
import { jwtDecode } from 'jwt-decode';

function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Google Sign-In Initialization (unchanged)
  useEffect(() => {
    const initializeGoogle = () => {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          client_id:
            '970749154398-4dcmlam48s2lqe5gqer3esm85dkchogs.apps.googleusercontent.com',
          callback: handleGoogleCallback,
        });

        window.google.accounts.id.renderButton(
          document.getElementById('googleSignInDiv'),
          { theme: 'outline', size: 'large', width: '100%' }
        );
      } else {
        setTimeout(initializeGoogle, 500);
      }
    };

    initializeGoogle();
  }, []);

  const handleGoogleCallback = async (response) => {
    try {
      jwtDecode(response.credential); // keeps behaviour; you can log/use if needed
      const res = await API.post('/auth/google-login', {
        token: response.credential,
      });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/');
    } catch (err) {
      setError('Google login failed');
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const normalizedEmail = form.email; // keep your existing behaviour
    const password = form.password?.trim();

    if (!normalizedEmail || !password) {
      setError('Email and password are required.');
      return;
    }

    try {
      const res = await API.post('/auth/login', {
        email: normalizedEmail,
        password,
      });

      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/');
    } catch (err) {
      const message =
        err.response?.data?.error || 'Login failed. Please try again.';
      setError(message);
    }
  };

  return (
    <div className="mm-login-container">
      {/* Left side hero */}
      <div className="mm-login-left">
        <div className="mm-welcome-message">
          <h1>Welcome To Merchant Marvels</h1>
          <p>
            Join our community of thousands and unlock exclusive insights daily
          </p>
        </div>
      </div>

      {/* Right side form */}
      <div className="mm-login-right">
        <div className="mm-login-logo-wrapper">
          <img
            src={logo}
            alt="Merchant Marvels"
            className="mm-login-logo"
          />
        </div>

        <div className="mm-login-form-wrapper">
          <form onSubmit={handleSubmit} className="mm-login-form">
            <h2 className="mm-login-title">Login</h2>
            <p className="mm-login-subtitle">
              Enter your credentials to continue
            </p>

            {error && <div className="mm-error-message">{error}</div>}

            <div className="mm-input-wrapper">
              <div className="mm-label">Email/ User Name</div>
              <input
                className="mm-login-input"
                name="email"
                type="email"
                placeholder="Enter Your Email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mm-input-wrapper">
              <div className="mm-label">Password</div>

              <div className="mm-password-container">
                <input
                  className="mm-login-input"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  value={form.password}
                  onChange={handleChange}
                  required
                />

                <span
                  className="mm-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </span>
              </div>
            </div>


            <div className="mm-login-options">
              <label className="mm-remember-me">
                <input type="checkbox" />
                <span>Remember Me</span>
              </label>
              <a href="/forgot-password" className="mm-link">
                Forgot Password ?
              </a>
            </div>

            <button className="mm-login-button" type="submit">
              Sign In
            </button>

            <p className="mm-login-footer">
              <div className="">
                New User ?{' '}
                <a href="/register" className="mm-link">
                  Sign Up Here For Free
                </a>
              </div>

              <a href="/emplogin" className="mm-link">
                Employee Login
              </a>
            </p>

            <div className="mm-divider">
              <div className="mm-divider-line" />
              <span className="mm-divider-text">Or Sign in with</span>
              <div className="mm-divider-line" />
            </div>

            <div className="mm-google-wrapper">
              {/* Google button renders into this */}
              <div id="googleSignInDiv" style={{ width: '100%' }} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
